export default __webpack_public_path__ + "static/media/V220_E_BD.bbf454da.pdf";